import { render } from "./characterPanel.vue?vue&type=template&id=4cecec26&scoped=true"
import script from "./characterPanel.vue?vue&type=script&lang=ts"
export * from "./characterPanel.vue?vue&type=script&lang=ts"

import "./characterPanel.vue?vue&type=style&index=0&id=4cecec26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cecec26"

export default script